/**
 * Thin wrappers over `@chatsdet/canary-spec`'s reverse-renderers, fixing which
 * renderer drives which surface:
 *
 *  - {@link toBlocks} — the human-readable, identity-keyed block model that the
 *    on-canvas view renders step-by-step (so each step keeps its `nodeId`).
 *  - {@link toFullFidelity} — the round-trippable, re-compilable `.cofactor.md`
 *    string for copy + download.
 *
 * @module FlowDesigner/spec/renderCofactorMd
 */

import {
  materializeWorkflowToBlocks,
  workflowToSpec,
  type PullWorkflow,
  type SpecDocBlock,
} from '@chatsdet/canary-spec/browser';

export type { SpecDocBlock };

export function toBlocks(live: PullWorkflow): SpecDocBlock[] {
  return materializeWorkflowToBlocks(live);
}

export function toFullFidelity(live: PullWorkflow): string {
  return workflowToSpec(live);
}

/** Filename-safe slug for the downloaded `.cofactor.md`. */
export function specFileName(name: string): string {
  const slug = name.replace(/[^a-zA-Z0-9-_ ]/g, '').trim().replace(/\s+/g, '-') || 'flow';
  return `${slug}.cofactor.md`;
}
